// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/common/v1/archive.proto (package chalk.common.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/common/v1/archive.proto.
 */
export const file_chalk_common_v1_archive: GenFile = /*@__PURE__*/
  fileDesc("Ch1jaGFsay9jb21tb24vdjEvYXJjaGl2ZS5wcm90bxIPY2hhbGsuY29tbW9uLnYxIn8KDUFyY2hpdmVTdGF0dXMSNAoLYXJjaGl2ZWRfYXQYASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSACIAQESGAoLYXJjaGl2ZWRfYnkYAiABKAlIAYgBAUIOCgxfYXJjaGl2ZWRfYXRCDgoMX2FyY2hpdmVkX2J5YgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.common.v1.ArchiveStatus
 */
export type ArchiveStatus = Message<"chalk.common.v1.ArchiveStatus"> & {
  /**
   * @generated from field: optional google.protobuf.Timestamp archived_at = 1;
   */
  archivedAt?: Timestamp;

  /**
   * @generated from field: optional string archived_by = 2;
   */
  archivedBy?: string;
};

/**
 * Describes the message chalk.common.v1.ArchiveStatus.
 * Use `create(ArchiveStatusSchema)` to create a new message.
 */
export const ArchiveStatusSchema: GenMessage<ArchiveStatus> = /*@__PURE__*/
  messageDesc(file_chalk_common_v1_archive, 0);

